
export default function Hero() {
  return (
    <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://static.readdy.ai/image/e4140a6110134fefa958645e77b5a66a/e039aa876d4ae4b8e2d4f25a80e1cfdf.jpeg"
          alt="Gleimatus Empreendimentos"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-black/70"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 py-20 text-center">
        {/* Logo Image */}
        <div className="mb-12">
          <img
            src="https://static.readdy.ai/image/e4140a6110134fefa958645e77b5a66a/cc1f1316833ca510742f9737478242fc.png"
            alt="Gleimatus Empreendimentos"
            className="h-48 w-auto mx-auto mb-6"
          />
        </div>

        {/* Main Heading */}
        <h2 className="text-4xl md:text-6xl font-bold text-white mb-6 tracking-tight">
          Construindo Valor,<br />Entregando Confiança
        </h2>

        {/* Subheading */}
        <p className="text-xl md:text-2xl text-white/90 mb-12 max-w-3xl mx-auto leading-relaxed">
          Especializada em incorporação e construção civil com foco em empreendimentos residenciais de alto padrão
        </p>

        {/* CTA Button */}
        <a
          href="#contato"
          className="inline-block bg-gradient-to-r from-amber-600 to-amber-500 hover:from-amber-700 hover:to-amber-600 text-white font-semibold px-12 py-4 rounded-full text-lg transition-all duration-300 shadow-2xl hover:shadow-amber-500/50 hover:scale-105 whitespace-nowrap cursor-pointer"
        >
          Fale Conosco
        </a>

        {/* Stats */}
        <div className="mt-20 grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
          <div className="bg-white/5 backdrop-blur-md rounded-2xl p-6 border border-white/10">
            <div className="text-4xl font-bold text-amber-400 mb-2">10+</div>
            <div className="text-white/90 text-sm uppercase tracking-wider">Anos de Experiência</div>
          </div>
          <div className="bg-white/5 backdrop-blur-md rounded-2xl p-6 border border-white/10">
            <div className="text-4xl font-bold text-amber-400 mb-2">R$ 1,1M+</div>
            <div className="text-white/90 text-sm uppercase tracking-wider">VGV em Empreendimentos</div>
          </div>
          <div className="bg-white/5 backdrop-blur-md rounded-2xl p-6 border border-white/10">
            <div className="text-4xl font-bold text-amber-400 mb-2">100%</div>
            <div className="text-white/90 text-sm uppercase tracking-wider">Compromisso com Qualidade</div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-line text-white text-3xl"></i>
      </div>
    </section>
  );
}
